// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML, sendXHR, failedRequest, returnEmailLink, sendUserData } from 'src/lib/utils.js';
import { ReactColourKey } from '../../ReactColourKey/jsx/component.jsx';
import { ReactBarChart } from '../../ReactBarChart/jsx/component.jsx';
import { ReactPieChart } from '../../ReactPieChart/jsx/component.jsx';


// Binds

// Stateful components

export const ReactDetailedReport = (props) => {

    const [{ globalText, userData, controlData, questionData, questionSectionData, modalData }, dispatch] = useStateValue();

    const {sectionId} = props;

    let strengths = {};
    let improvements = [];
    let reportHTML;
    localStorage.setItem('sectionId', sectionId);
    

    /*  
        As we are storing as an object, the order is being sorted by js on the assetID so we need to sort it based on the asset tree order.
        posIndex is added to the data within Matrix in the asset listing via asset_position.
    */

    const sortQuestions = (a,b) => {
        return parseInt(a.posIndex) > parseInt(b.posIndex) ? 1 : -1;
    }

    // if there is strenth content build the list to be diplayed
    const returnStrengthsList = () => {

        let questionArray = strengths[sectionId];
        if (typeof(questionArray) !== 'undefined') {

            //sort the questions by posIndex
            questionArray.sort(sortQuestions);
            let content = questionArray.map((item, idx1) => {
                return <li key={idx1} className="br-app-main-content__report__list__item br-app-main-content__report__list__item--strength"><span>{item.q_report_strength} </span> </li>;
            });
            content = <ul className="br-app-main-content__report__list"> {content}</ul>
        
            return <div 
                className="br-app-main-content__strengths">
                <h2>{globalText.reportStrengthsLabel}</h2>
                {content}
            </div>;

        }
        
    }

    // if there is improvement content build the list to be diplayed
    const returnImprovementsList = () => {

        let questionArray = improvements[sectionId];

        if (typeof(questionArray) !== 'undefined') {
            
            //sort the questions by posIndex
            questionArray.sort(sortQuestions);

            let list = questionArray.map((item2, idx2) => {

                let weaknessText, weaknessResource;
                
                weaknessText = item2.q_report_weakness;
                weaknessResource = item2.q_report_resource;



                //------------------------------------------------
                // Response Variants - Start
                // NOTE: used within ReactReport and ReactDetailedReport
                //------------------------------------------------
                //get the select field that will be used for response variants
                let variantSelect = globalText.reportVariantSelectAssetID;

                //get the selected answer value 
                let variantValue = typeof(userData.questionResponses) !== 'undefined' ? userData.questionResponses[variantSelect] : [];
                
                //if we have a variation the question
                if(typeof(item2.q_response_variations) !== 'undefined'){
                    
                    //get the variant for the users selected response
                    let variationObject = item2.q_response_variations.find((variation_item) => {
                      //  if(variation_item.variant === variantValue)
                      if(variation_item.variant.indexOf(variantValue) !== -1)                        
                      {                            
                            return variation_item;
                        }
                    });

                    //if we have a variant of the texts add them 
                    if(typeof(variationObject) !== "undefined"){
                        //if there is a weakness variant
                        if(variationObject.weakness_var != ""){
                            weaknessText = variationObject.weakness_var;
                        }
                        //if there is a weakness resource variant
                        if(variationObject.resourse_var != ""){
                            weaknessResource = variationObject.resourse_var;
                        }
                    }
                }
                //------------------------------------------------
                // Response Variants - END
                //------------------------------------------------

                

                return <li key={idx2} className="br-app-main-content__report__list__item br-app-main-content__report__list__item--improvement">
                    <h4 key={idx2 + "_span"}>{weaknessText} </h4>
                    <div key={idx2 + "_div"} dangerouslySetInnerHTML={{ __html: weaknessResource }}></div>
                </li>;
            });
            list = <ul  className="br-app-main-content__report__list"> {list}</ul>

            return <div className="br-app-main-content__improvements">
                <h2>{globalText.reportImprovementsLabel}</h2>
                {list}
            </div>;
        }

    }

    // returns the base URL of the current location
    const returnURL = () => {
        return window.location.href.split('?')[0];
    }

/*
    // ruturns a link for users to return to the report. Builds it from the user data
    const returnEmailLink = ($userData) => {
        //currentAssetID == current
        //availableNavItems == b
        //questionResponses == c

        let data = $userData;
        let currentAsset = data.currentAssetID;
        let navItems = data.availableNavItems;
        let expandedItem = data.expandedItem;
        let responses = data.questionResponses;
        let uuid = data.uniqueUserID;

        //get the initial Email
        let url = window.location.href.split('?')[0];
        //set this as we do diffent things if we know they have returned via this link
        url += '?return=email';
        // add the unique user id
        url += '&uuid=' + uuid;
        //add the expanded asset
        url += '&ei=' + expandedItem;
        // add the current Asset
        url += '&current=' + currentAsset;

        // add the available progression nav asset ids
        let b = navItems.join(',');
        url += '&b=' + b;

        // make a array of objects of the question asset ids and the users response to the question
        let keys = Object.keys(responses).map((item) => {
            return item + '_' + responses[item];
        });

        let c = keys.join(',');
        url += '&c=' + c;
        //console.log(url);
        return url;
    }*/

    //Test if the user data has been submitted, if not send it
    React.useEffect( () =>{
        // if we havent submitted the data 
        if(controlData.hasSubmittedContent === false){
            //sendUserData();
            sendUserData(globalText,userData,sendUserDataSuccess,sendUserDataFailure);
        }else{
            // if we have submitted the data, but it has changed submit again
            let emailLink = returnEmailLink(userData);            
           // if(controlData.submittedContentStrings !== emailLink){
            if(controlData.submittedContentStrings.indexOf(emailLink) == -1){
                //sendUserData();
                controlData.submittedContentString = emailLink;
                sendUserData(globalText,userData,sendUserDataSuccess,sendUserDataFailure);
            }
        }
        // add Email Event listeners links
        let allLinks = document.querySelectorAll('.br-app-main-content__email-print__email__link');
        allLinks.forEach((item) => {
            item.addEventListener('click', emailButtonClickHandler);
        })


    }, []
    )
/*
    //sends the user data url to Matrix
    const sendUserData = ($globalText,$userData,$successCallback,$failCallback) => {
        //if(controlData.hasSubmittedContent === false){
            let formURL = $globalText.submitContentURL;
            let data = returnEmailLink($userData);
            //console.log('sending user data');

            let assetID = Number($globalText.submitContentAssetID) + 1;
            let pageName = 'SQ_FORM_' + assetID + '_PAGE';
            let refName = 'form_email_' + assetID + '_referral_url'
            let qName = 'q' + assetID + ':q1';
            let submitName = 'form_email_' + assetID + '_submit';

            let formData = new FormData();
            formData.append(pageName,1);
            formData.append(refName,'https://www.business.qld.gov.au/_admin/');            
            formData.append(qName,data);
            formData.append(submitName,'Submit');
            let xhr_parameters = {
                'request_url': formURL,
                'request_success': $successCallback,
                'request_failure': $failCallback,
                'request_extras': formData
            };

            sendXHR(xhr_parameters ,'FORM_POST');

       // }
    }*/

    

    // success for sendUserData
    const sendUserDataSuccess = () => {
        let emailLink = returnEmailLink(userData);
        dispatch({
            type: 'userDataSubmitted',
            value: emailLink        
        });
    }

    // fail for sendUserData - we can ignore it
    const sendUserDataFailure = () => {
       // console.log("Data Sending Failed")
    }

    const emailClickHandler = (e) => {
        e.preventDefault();
        sendEmailToUser();

    }

    const backToReportClickHandler = (e) => {
        e.preventDefault();

        dispatch({
            type: 'showProgressReportModal',
            value: { modalContent: reportHTML}
        });
    }

    //sends the user data url to a Matrix Form which sends email to user
    const sendEmailToUser = () => {
       
        let formContentsAssetID = globalText.modalEmailSubmissionAssetID;
        let emailInput = document.querySelector('#q'+ formContentsAssetID +'_q1');
        if (!emailInput.checkValidity()) {
            document.querySelector("#app_email-valid").innerText = emailInput.validationMessage;
        } else {

            let formURL = globalText.modalEmailSubmissionURL;
            let emailLink = returnEmailLink(userData);
            let appURL = returnURL();

            //let formContentsAssetID = globalText.modalEmailSubmissionAssetID;
            let userEmail = document.querySelector("#q"+formContentsAssetID+"_q1").value;
           
            let formData = new FormData();
            formData.append('SQ_FORM_'+formContentsAssetID+'_PAGE',1);
            formData.append('form_email_'+formContentsAssetID+'_referral_url','https://www.business.qld.gov.au/_admin/');
            formData.append('q'+formContentsAssetID+':q1',userEmail);
            formData.append('q'+formContentsAssetID+':q2',emailLink);
            formData.append('q'+formContentsAssetID+':q3',appURL);
            formData.append('form_email_'+formContentsAssetID+'_submit','Submit');
            let xhr_parameters = {
                'request_url': formURL,
                'request_success': sendEmailSuccess,
                'request_failure': sendEmailFailure,
                'request_extras': formData
            };

            sendXHR(xhr_parameters ,'FORM_POST');
            dispatchEmailIsSending();            
        }
    }

    const dispatchEmailIsSending = () =>{
        dispatch({
            type: 'emailSendLoading'
        });      
    }

    // success for sendEmailToUser, dispatches events to show the various modals
    const sendEmailSuccess = (e) => {
        // response from matrix is a JSON object with success
        // anything else is considered a fail
        if (JSON.parse(e).submission === "success"){
            dispatch({
                type: 'emailSendSuccess'
            });
        }else{
            dispatch({
                type: 'emailSendFail'
            });
        }
    }

    // fail for sendEmailToUser
    const sendEmailFailure = (e) => {       
        dispatch({
            type: 'emailSendFail'
        });
    }

    //invalid listener for email input field, set the custom validation message
    const onInvalid = (e) => {  
        e.target.setCustomValidity(globalText.emailValidationMessage);
    }

    //input listener for email input field to clear the custom validation message
    const onInput = (e) => {
        e.target.setCustomValidity('');
        
    }    

    //sets the Modal Data to the Email Modal components
    const setEmailModal = () => {
        let formContentsAssetID = globalText.modalEmailSubmissionAssetID;
        let newModalData = modalData;
        newModalData.title = globalText.modalEmailTitle,
        newModalData.wideModal = false;
        newModalData.showModal = false;
        newModalData.content = <>
                <form id="app_email_form" onSubmit={emailClickHandler} >
                    <input type="email" required placeholder={globalText.modalEmailInputPlaceholder} id={"q"+ formContentsAssetID + "_q1"} pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{1,}[.]{1}[a-zA-Z0-9]{2,}" onInvalid={onInvalid}
                    onInput={onInput} />
                    <input type="hidden" id={"q" + formContentsAssetID + "_q2"} />
                    <p id="app_email-valid"></p>
                </form>
                <div dangerouslySetInnerHTML={dangerousHTML(globalText.modalEmailLabelNotice)}></div>
            </>
        newModalData.buttons = [{ action: 'custom', clickHandler: emailClickHandler, class: "br-app-btn", label: globalText.modalEmailBtnLabelSubmit }, {action: 'custom', clickHandler: backToReportClickHandler, class: "br-app-btn", label: globalText.modalEmailBtnLabelCancel }]
    }

    // listener for when users click Email Report button - shows the Email Modal
    const emailButtonClickHandler = (event) => {
        event.preventDefault();        
        setEmailModal();
        dispatch({
            type: 'modalToggleClick',
            value: 'email'
        });
    }

    // listener for when users click Print Report
    const printReport = (event) => {
        event.preventDefault();
        
        // Add element if it's not already there
        if ( document.querySelector('.printable-content') === null ) {
            let new_child = document.createElement("div");
            new_child.classList.add('printable-content');
            let pageWrapper = document.querySelector('#page-wrapper');
            if(pageWrapper !== null){
                pageWrapper.appendChild(new_child);
            }
            
        }

        // Clear it
        let print_area = document.querySelector('.printable-content');
        while (print_area.firstChild){
            print_area.removeChild(print_area.firstChild);
        }

        let content = document.querySelector('.appModal__container').innerHTML;
        document.querySelector('.printable-content').innerHTML = content;

        window.print();
    }

    // Calculate user score of given detailed assessment section
    const getUserResultsOfDetailedAssessmentSection = () => {
        let detailSection = questionSectionData[sectionId];
        let sectionQuestions = detailSection.children;

        if (typeof(sectionQuestions) !== 'undefined') {
            


            //filter out the questions that are linked to rapid assessment questions in which the user has selected Yes(0);
            var filteredQuestions = sectionQuestions.filter((question) =>{
                if(typeof(question.linkedRapidQuestion) !== "undefined"){
                    if(question.linkedRapidQuestion !== ""){
                        var userResponse = userData.questionResponses[question.linkedRapidQuestion]; 
                        //if the user has answered yes(0) - then do not show this question
                        if(userResponse === 0){
                            return false;
                        }
                    }
                    return true;
                }
                return true;
            });

            let noOfQuestions = filteredQuestions.length;


            let totalScore = 0;
            
            //sectionQuestions.forEach(question => {
            filteredQuestions.forEach(question => {
                let assetID = question.assetID;
                const maxValue = question.rangeSliderMax ? question.rangeSliderMax - 1 : 4;

                // A bottom slider value of '1' should actually be worth 0
                let score;
                let percentageScore;
                
                if(question.qType === 'rangeSlider') {
                    score = userData.questionResponses[assetID] - 1;
                    percentageScore = score / maxValue * 100;
                } else if (question.qType === 'threeAnswers' || question.qType === 'fourAnswers') {
                    score = userData.questionResponses[assetID];
                    if (score == 0) {
                        percentageScore = 100;
                    } else {
                        percentageScore = 0;
                    }

                    if (score == 3) {
                        score = -1;
                    }
                }


                if (score < 0) { // Discount disabled questions
                    noOfQuestions--;
                } else {
                    totalScore += percentageScore;
                }
            });

            let averageScore = Math.ceil(totalScore / noOfQuestions);
            // console.log("totalScore for section:",detailSection.navName ,totalScore);
            // console.log("percentage score for section:",detailSection.navName ,averageScore);

            return averageScore;
        }
        
        return 'N/A';
    }

    // Builds the Strengths and Improvement variables 
    const buildAnswers = () => {

        let userAnswers = Object.entries(userData.questionResponses);
        
        userAnswers.forEach((item) => {
            let itemAssetID = item[0];
            let itemValue = item[1] - 1;
            let answerItem = questionData[itemAssetID];

            // last answerItem returns as undefined?
            if(typeof(answerItem) !== 'undefined') {
                if(answerItem.assessmentType == 'detailed') {
                    const scoreThreshold = globalText.detailedReportThreshold ? globalText.detailedReportThreshold : 60;
                    
                    const maxValue = answerItem.rangeSliderMax ? answerItem.rangeSliderMax - 1 : 4;

                    let percentageResult;

                    
                    if(answerItem.qType === 'rangeSlider') {
                        percentageResult = itemValue / maxValue * 100;
                    } else if (answerItem.qType === 'threeAnswers' || answerItem.qType === 'fourAnswers') {
                        if (item[1] == 0) {
                            percentageResult = 100;
                        } else if (item[1] == 3) {
                            percentageResult = -1;
                        } else {
                            percentageResult = 0;
                        }
                    }

                    // If percentage score is above the threshold, then it is a strength
                    if (percentageResult > Number(scoreThreshold)) {
                        if (typeof strengths[answerItem.parentQuestionSection] === 'undefined') {
                            strengths[answerItem.parentQuestionSection] = [];
                        }                   
                        strengths[answerItem.parentQuestionSection].push(answerItem);  

                    // Otherwise, it's a weakness (<0 indicates a disabled field so those are discounted)
                    } else if (percentageResult >= 0) {
                        if (typeof improvements[answerItem.parentQuestionSection] === 'undefined') {
                            improvements[answerItem.parentQuestionSection] = [];
                        }
                        improvements[answerItem.parentQuestionSection].push(answerItem);

                    }
                }
            }
        })
    }

    buildAnswers();

    const returnReportHtml = () => {
        let colourKey = '';
        let chart = '';
        if(globalText.barChartRange_weakness == '' && globalText.barChartRange_strength == '') {
            chart = <ReactPieChart result={userScore} noColor={"true"}/>
        } else {
            chart = <ReactBarChart userScore={userScore} industryScore={Number(questionSectionData[sectionId]['industryScore'])} />
            colourKey = <ReactColourKey />
        }

        return (
            <div>

                <div className="br-app-main-content__email-print br-app-main-content__email-print--top">
                    <div className="br-app-main-content__email-print__email">
                        <a href="#" onClick={emailButtonClickHandler} className="br-app-main-content__email-print__email__link"><span className="br-app-main-content__email-icon" aria-hidden="true"></span>{globalText.reportEmailLabel}</a>
                    </div>
                    <div className="br-app-main-content__email-print__print">
                        <a href="#" onClick={printReport} className="br-app-main-content__email-print__print__link">
                            <span className="br-app-main-content__print-icon" aria-hidden="true"></span>
                            {globalText.reportPrintLabel}
                        </a>
                    </div>
                </div>

                <hr />

                <div dangerouslySetInnerHTML={dangerousHTML(questionSectionData[sectionId]['reportContent'])}></div>

                <h3>{questionSectionData[sectionId]['headerText']}</h3>

                {colourKey}
                {chart}

                <hr />

                {returnStrengthsList()}
                {returnImprovementsList()}
                
                <div className="br-app-main-content__discover-more">
                    <h2>{globalText.reportDiscoverMoreLabel}</h2>
                    
                    <div dangerouslySetInnerHTML={dangerousHTML(globalText.reportDiscoverMoreContent)}></div>
                </div>

                <div className="br-app-main-content__additional-content">
                    { (globalText.reportAdditionalContentLabel) ? <h2>{globalText.reportAdditionalContentLabel}</h2> : '' }
                    
                    <div dangerouslySetInnerHTML={dangerousHTML(globalText.reportAdditionalContentContent)}></div>
                </div>
            
                <div className="br-app-main-content__email-print ">
                    <div className="br-app-main-content__email-print__email">
                        <a href="#" className="br-app-main-content__email-print__email__link"><span className="br-app-main-content__email-icon" aria-hidden="true"></span>{globalText.reportEmailLabel}</a>
                    </div>
                    <div className="br-app-main-content__email-print__print">
                        <a href="#" onClick={printReport} className="br-app-main-content__email-print__print__link">
                            <span className="br-app-main-content__print-icon" aria-hidden="true"></span>
                            {globalText.reportPrintLabel}
                        </a>
                    </div>
                </div>

            </div>
        );
    }
    
    let userScore = getUserResultsOfDetailedAssessmentSection();
    
    reportHTML = returnReportHtml();

    return (
        <div>
            { returnReportHtml()}
        </div>
    );
};
